/*
  Leefy Organics - subscription cadence follows quantity  (RC, 2026-08-27)
  ------------------------------------------------------------------------
  APPROVED BY CARL 2026-08-27. Replaces recharge-frequency-automatch.js
  (that file was week-based and is now obsolete - delete it).

  WHAT THIS DOES on every PDP buy box:
    1. The bottle-quantity tile now sets the renewal interval:
         variant 1 (1 bottle  / base bundle)      -> renews every 1 month
         variant 2 (2 bottles / 2x base bundle)   -> renews every 2 months
         variant 3 (4 bottles / 4x base bundle)   -> renews every 4 months
       Single-variant products (FOUR BUNDLE, Total Health Bundle) stay monthly.
    2. The "Delivery" dropdown is removed from the page - the shopper no
       longer picks a cadence. They can still change frequency after purchase
       in the Recharge customer portal ("Skip or cancel anytime" already says so).
    3. In the dropdown's place a PLAIN-TEXT line states the renewal interval,
       e.g. "Renews every 2 months". This line is REQUIRED, not decorative:
       US auto-renewal law (ROSCA; California ARL) requires the renewal
       frequency to be disclosed clearly before purchase. Do not remove it.

  HOW IT WORKS
    The theme's buy box keeps a <select id="sub-delivery-frequency"> whose
    option values ARE the Shopify selling-plan ids. global.js already listens
    to that select to re-price and to write the hidden `selling_plan` input.
    So this script only has to set the select's value and fire `change` -
    all pricing and cart wiring downstream is the theme's existing code.
    Plans are matched by parsing the option labels ("Delivery every N months"),
    so no plan ids are hardcoded and new products work automatically.

  INSTALL (theme PMT-LFO-001, Dawn-derived)
    1. Online Store > Themes > ... > Edit code
    2. Assets > Add a new asset > upload this file as
         leefy-subscription-cadence.js
    3. layout/theme.liquid - directly AFTER the line that loads global.js:
         <script src="{{ 'global.js' | asset_url }}" defer="defer"></script>
       add:
         <script src="{{ 'leefy-subscription-cadence.js' | asset_url }}" defer="defer"></script>
    4. Save. No edits to global.js or snippets/subscription-widget.liquid.

  ROLLBACK: remove the one <script> line. Nothing else is modified.
*/
(function () {
  'use strict';

  // variant position (0-indexed) -> renewal interval in months
  var MONTHS_BY_VARIANT_POSITION = [1, 2, 4];

  function parseMonths(label) {
    var m = /every\s+(\d+)\s*(month|week|day)/i.exec(label || '');
    if (!m) return null;
    var n = parseInt(m[1], 10);
    var unit = m[2].toLowerCase();
    if (unit === 'month') return n;
    if (unit === 'week') return n / 4.345;   // legacy plans, if any survive
    if (unit === 'day') return n / 30.4;
    return null;
  }

  function getSelect() {
    return document.querySelector('#sub-delivery-frequency');
  }

  // the plan id whose interval is closest to `months`
  function planIdForMonths(months) {
    var select = getSelect();
    if (!select) return null;
    var best = null, bestDiff = Infinity;
    Array.prototype.forEach.call(select.options, function (o) {
      var m = parseMonths(o.textContent);
      if (m === null) return;
      var diff = Math.abs(m - months);
      if (diff < bestDiff) { bestDiff = diff; best = o.value; }
    });
    return best;
  }

  function currentVariantPosition(widget) {
    try {
      var variants = widget.getVariants() || [];
      if (variants.length < 2) return 0;
      var el = widget.getEl();
      var id = el && el.dataset.currentVariantId;
      var idx = variants.findIndex(function (v) { return String(v.id) === String(id); });
      return idx < 0 ? 0 : idx;
    } catch (e) { return 0; }
  }

  function targetMonths(widget) {
    var variants = [];
    try { variants = widget.getVariants() || []; } catch (e) {}
    if (variants.length < 2) return 1;                       // single-variant product
    var pos = currentVariantPosition(widget);
    return MONTHS_BY_VARIANT_POSITION[pos] || MONTHS_BY_VARIANT_POSITION[MONTHS_BY_VARIANT_POSITION.length - 1];
  }

  // --- the visible renewal line (replaces the dropdown) ---------------------
  function ensureNoticeEl() {
    var select = getSelect();
    if (!select) return null;
    var block = select.closest('.hsw-delivery');
    if (!block) return null;

    // hide the label + select, keep the block as our text row
    var label = block.querySelector('.hsw-delivery-label');
    var wrapper = block.querySelector('.hsw-delivery-select-wrapper');
    if (label) label.style.display = 'none';
    if (wrapper) wrapper.style.display = 'none';

    var notice = block.querySelector('.leefy-renewal-note');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'leefy-renewal-note';
      notice.style.cssText = 'font-size:14px;line-height:1.4;opacity:.85;';
      block.appendChild(notice);
    }
    return notice;
  }

  function renderNotice(months) {
    var notice = ensureNoticeEl();
    if (!notice) return;
    notice.textContent = months === 1
      ? 'Renews every month'
      : 'Renews every ' + months + ' months';
  }

  // --- keep the select in sync with the chosen quantity ---------------------
  function applyCadence(widget) {
    var months = targetMonths(widget);
    var select = getSelect();
    renderNotice(months);
    if (!select) return;
    var planId = planIdForMonths(months);
    if (planId && select.value !== planId) {
      select.value = planId;
      // global.js listens for change: it re-prices and rewrites selling_plan
      select.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      try { widget.syncSellingPlanToForm(); } catch (e) {}
    }
  }

  function install() {
    var widget = window.SubscriptionWidget;
    if (!widget || widget.__leefyCadenceInstalled) return;
    if (!getSelect()) return;                                // not a subscription PDP
    widget.__leefyCadenceInstalled = true;

    var originalUpdate = widget.updateFromVariantSelects.bind(widget);
    widget.updateFromVariantSelects = function (variantSelects) {
      originalUpdate(variantSelects);                        // resolves + records the variant
      applyCadence(this);                                    // then set cadence for that variant
    };

    // subscribe / one-time toggles re-sync the hidden input
    ['#custom-subscribe', '#custom-onetime'].forEach(function (sel) {
      var box = document.querySelector(sel);
      if (box) box.addEventListener('click', function () {
        setTimeout(function () { applyCadence(widget); }, 0);
      });
    });

    applyCadence(widget);                                    // initial load
  }

  function boot() {
    install();
    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      if (window.SubscriptionWidget && getSelect()) { install(); }
      if (tries > 60 || (window.SubscriptionWidget && window.SubscriptionWidget.__leefyCadenceInstalled)) {
        clearInterval(t);
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
